export const docsRegexp = /\[(doc\d{1,3}(?:,\s*doc\d{1,3})*)]/g;
export const reduntantWhitespaceRegexp = /\s{2,}/g;
export const exactDocRefRegexp = /^doc\d{1,3}$/;
